export default __webpack_public_path__ + "static/media/ar.2f229d90.jpg";